import { type TemplateData } from '@/lib/builder/types'
import { OlympusClient } from '@/OlympusClient'

import {
  type WebsiteResourceCreate,
  type WebsiteSectionCreate,
} from '../WebsiteBuilder.types'

export const blankTemplate = async (
  brandId: string
): Promise<TemplateData<WebsiteResourceCreate, WebsiteSectionCreate>> => {
  const funnel = await OlympusClient.funnel.v1.brands.brand.getFunnel({
    params: { brandId },
  })

  return {
    blocks: [],
    resource: {
      brandId,
      funnel,
      path: { params: { locationId: null, slug: 'custom' }, type: 'custom' },
      sections: [],
      title: 'blank',
    },
  }
}
